import AsyncSelect from "react-select/async";
import { FC } from "react";
import { gql, useLazyQuery } from "@apollo/client";

const SEARCH_CATEGORIES = gql`
  query SearchCategories($search: String!, $first: Int!) {
    categories(search: $search, first: $first) {
      edges {
        node {
          dbId
          name
        }
      }
    }
  }
`;

interface CategoryChooserProps {
  fieldLabel: string;
  fieldSchema?: { description?: string };
  isMulti?: boolean;
  defaultOptions?: any[];
  value: any;
  onChange: (selected: any) => void;
  [key: string]: any;
}

const CategoryChooser: FC<CategoryChooserProps> = ({
  fieldLabel,
  fieldSchema,
  isMulti = false,
  defaultOptions = [],
  value,
  onChange,
  ...commonProps
}) => {
  const [searchCategories] = useLazyQuery(SEARCH_CATEGORIES);

  const loadOptions = async (inputValue: string) => {
    try {
      const { data } = await searchCategories({
        variables: { 
          search: inputValue || "",
          first: 10
        }
      });

      if (!data?.categories?.edges) {
        return [];
      }

      return data.categories.edges.map((edge: any) => ({
        value: edge.node.dbId,
        label: edge.node.name
      }));
    } catch (error) {
      console.error('Error loading categories:', error);
      return [];
    }
  };

  return (
    <div {...commonProps}>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {fieldLabel}
      </label>
      <AsyncSelect
        isMulti={isMulti}
        cacheOptions
        defaultOptions={[]}
        value={value || []}
        onChange={onChange}
        loadOptions={loadOptions}
        className="react-select-container"
        classNamePrefix="react-select"
        placeholder="Search categories..."
        noOptionsMessage={() => "No categories found"}
        loadingMessage={() => "Loading categories..."}
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({
            ...base,
            zIndex: 9999
          })
        }}
      />
      {fieldSchema?.description && (
        <p className="mt-1 text-sm text-gray-500">{fieldSchema.description}</p>
      )}
    </div>
  );
};

export default CategoryChooser; 